import App from './App.svelte';

const app = new App({
	target:  document.querySelector('#monio-graf')
});

export default app;